import { Language } from './language.model';

export class Country {
  name: string;
  native: string;
  shortCode: string;
  phone: string;
  continent: string;
  capital: string;
  currency: string;
  languages: Language[];
}



// WEBPACK FOOTER //
// ./src/config/i18n/models/country.model.ts